import { StatsDataBrokerInterface } from 'pf-frontend-common/src/module/stats/data/broker.interface';

import { BrokerModel } from 'common/data/broker/model';

export class BrokerStatsDataAdapter {
  /**
   * Return an broker model as broker stats data
   *
   * @param position - SERP position
   */
  public getData(brokerModel: BrokerModel, position?: number, positionPage?: number): StatsDataBrokerInterface {
    return {
      id: parseInt(brokerModel.id, 10),
      name: brokerModel.name,
      position: position || 0,
      positionPage: positionPage || position || 0,
      isSmartAd: 0,
      listingStatus: 'standard', // broker doesn't support listing_level yet
    };
  }
}
